export const EVENT_BUS_SESSION_CUSTOM_ENTITIES_CHANGED = 'gd.session.customEntities:change'